import { render, staticRenderFns } from "./BottomCta.vue?vue&type=template&id=22e99465"
import script from "./BottomCta.vue?vue&type=script&lang=js"
export * from "./BottomCta.vue?vue&type=script&lang=js"
import style0 from "./BottomCta.vue?vue&type=style&index=0&id=22e99465&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports